<template>
  <div class="page-view pt-4 pb-4">
    <div class="container">
      
      <div class="clearfix"></div> 
      <div class="groups-pdr"> 
        <RwvLoader :isLoading="isProductLoading" :fullPage="false"></RwvLoader>
        <RwvProductListItem :products="products"/>        
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RwvProductListItem from "@/components/ProductListItem";
import { FETCH_PRODUCTS } from '@/store/actions.type';
import RwvLoader from "@/components/Loader";

export default {
  name: "RwvProduct",
  components: {
    RwvProductListItem,
    RwvLoader
  },
  mounted() {
    this.$store.dispatch(FETCH_PRODUCTS);
  },
  computed: {
    ...mapGetters(["products", "isProductLoading"])
  }
};
</script>